import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
import { projectPageSsrEnabledProps } from "shared/pages/project/ssr/routesProps";

const ProjectBilingual = lazy(() => import("shared/pages/ProjectBilingual"));
const ProjectEditPage = lazy(() => import("shared/pages/projectEdit"));
const ProjectPageDeziign = lazy(() => import("shared/pages/project"));

const projectRoutes = [
    { path: LinkTo.project, exact: true, component: () => <ProjectPageDeziign className="white_theme" />, ...projectPageSsrEnabledProps },
    { path: LinkTo.preview, exact: true, component: () => <ProjectPageDeziign className="white_theme"/> },
    { path: LinkTo.bilingual, exact: true, component: ProjectBilingual },
    { path: LinkTo.projectEdit, exact: true, isPrivate: true, component: ProjectEditPage },
    { path: LinkTo.projectCreate, exact: true, isPrivate: true, component: ProjectEditPage },
];

export default projectRoutes;import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
import { projectPageSsrEnabledProps } from "shared/pages/project/ssr/routesProps";

const ProjectBilingual = lazy(() => import("shared/pages/ProjectBilingual"));
const ProjectEditPage = lazy(() => import("shared/pages/projectEdit"));
const ProjectPageDeziign = lazy(() => import("shared/pages/project"));

const projectRoutes = [
    { path: LinkTo.project, exact: true, component: () => <ProjectPageDeziign className="white_theme" />, ...projectPageSsrEnabledProps },
    { path: LinkTo.preview, exact: true, component: () => <ProjectPageDeziign className="white_theme"/> },
    { path: LinkTo.bilingual, exact: true, component: ProjectBilingual },
    { path: LinkTo.projectEdit, exact: true, isPrivate: true, component: ProjectEditPage },
    { path: LinkTo.projectCreate, exact: true, isPrivate: true, component: ProjectEditPage },
];

export default projectRoutes;